import {
  type ExternalLink as ExternalLinkType,
  selectTabExternalLinks,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { ExternalLink } from './components/ExternalLink'
import css from './ExternalLinks.module.scss'

const ExternalLinks: React.FC = () => {
  const activeTab = useSelector(migrationProjectSelector.getActiveOrFirstTabId)

  const externalLinks = useSelector<AppState, ExternalLinkType[]>((state) =>
    selectTabExternalLinks(activeTab)({
      project: state.manager.project,
      relations: state.relations,
    })
  )

  return (
    <div className={css.container}>
      {externalLinks.map((externalLink) => (
        <ExternalLink key={externalLink.id} link={externalLink} />
      ))}
    </div>
  )
}

export default ExternalLinks
